import {set, filter} from "lodash"
import REWARD from "../constants"

const initialState = {
  reward: {},
  load: null,
  touched: false,
  referenceData: {
    locale: [],
    status: []
  }
}

const RewardAdminReducer = (state = initialState, action) => {
  const {reward, load, key, value, product, referenceData} = action
  switch (action.type) {
    case REWARD.SET_VALUE:
      return setRewardValue(state, reward, key, value)
    case REWARD.SET_OBJECT:
      return setReward(state, reward)
    case REWARD.SET_LOAD:
      return setLoad(state, load)
    case REWARD.SET_REFERENCE_DATA:
      return setReferenceData(state, referenceData)
    case REWARD.ADD_PRODUCT:
      return addProduct(state, reward, product)
    case REWARD.REMOVE_PRODUCT:
      return removeProduct(state, reward, product)
    default:
      return state
  }
}

export default RewardAdminReducer

function addProduct(state, reward, product) {
  const products = reward.products || []
  products.push({
    uuid: product.uuid,
    name: product.name,
    type: product.type,
    supplier: product.supplier,
    price: product.price,
    currency: product.currency
  })
  return setRewardValue(state, reward, "products", products)
}

function removeProduct(state, reward, product) {
  const products = filter(reward.products, (compare) => compare.uuid !== product.uuid)

  return setRewardValue(state, reward, "products", products)
}

function setRewardValue(state, reward, key, value) {
  set(reward, key, value)
  return {
    ...state,
    touched: true,
    reward: {
      ...reward
    }
  }
}

function setReward(state, reward) {
  return {
    ...state,
    touched: false,
    reward
  }
}

function setLoad(state, load) {
  return {
    ...state,
    load
  }
}

function setReferenceData(state, referenceData) {
  return {
    ...state,
    referenceData
  }
}
